import React, { FC, useContext, useMemo } from 'react';

import { useMutation, useQuery } from '@apollo/client';
import { Table } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';
import {
  IStopClientSessionRequest,
  IStopClientSessionResponse,
} from 'modals/StopClientSessionModal/intefaces';
import { STOP_CLIENT_SESSION } from 'modals/StopClientSessionModal/schema';
import {
  GET_PAUSABLE_TARIFF,
  IPausableClientSessionsRequest,
  IPausableClientSessionsResponse,
} from 'schemas';

import { IPausableTariffProps } from './interfaces';
import s from './PausableTariff.module.scss';
import { getColumns } from './utils';

export const PausableTariff: FC<IPausableTariffProps> = ({ clientUUID }) => {
  const { t } = useContext(LocalizationContext);

  const { data, loading } = useQuery<
    IPausableClientSessionsResponse,
    IPausableClientSessionsRequest
  >(GET_PAUSABLE_TARIFF, {
    variables: {
      clientId: clientUUID,
    },
    fetchPolicy: 'no-cache',
  });

  const [stopClientSession] = useMutation<
    IStopClientSessionResponse,
    IStopClientSessionRequest
  >(STOP_CLIENT_SESSION, { refetchQueries: [GET_PAUSABLE_TARIFF] });

  const COLUMNS = useMemo(() => getColumns(t, stopClientSession), [t, data]);

  return (
    <Table
      columns={COLUMNS}
      data={data?.pausableClientSessions ?? []}
      emptyDataPlaceholder={t('pausable_tariff.notDate')}
      isLoading={loading}
      className={s.table}
    />
  );
};
